module.exports = __webpack_public_path__ + "img/fastbridge.56b23697.png";